import { Component, Input, OnInit, ElementRef, OnChanges, SimpleChanges } from '@angular/core';
import { MessageService } from '../../../../../core';
import { RecursoCampanhaBase } from '../../recurso-campanha-base';
import { recursoCampanhaTipoInvestimento, recursoCampanhaTipoProduto, recursoCampanhaTipoServico } from '../../tipo';
import { RecursoCampanhaFormTipo } from './recurso-camanha-form-tipo';


@Component({
    selector: 'sgt-recurso-campanha-form',
    templateUrl: './recurso-campanha-form.component.html',
    styleUrls: ['./recurso-campanha-form.component.less']
})
export class RecursoCampanhaFormComponent implements OnChanges {
    valorTotal = 0;
    tipos: RecursoCampanhaFormTipo[];

    @Input() idArea: number;
    @Input() recursos: RecursoCampanhaBase[] = [];
    @Input() isShowValorTotal = true;
    @Input() valorTotalHelpText: string = null;
    @Input() canEdit = true;

    // Layout
    @Input() cardHeaderStickyTop = '-15px';

    constructor(private el: ElementRef,
                private messageService: MessageService) { }


    ngOnChanges(changes: SimpleChanges): void {
        for (const propName in changes) {
            if (propName === 'recursos') {
               this.create();
            }
        }
    }

    private create() {
        this.tipos = [];
        this.tipos.push(new RecursoCampanhaFormTipo(recursoCampanhaTipoInvestimento, this.recursos, 'card-investimentos'));
        this.tipos.push(new RecursoCampanhaFormTipo(recursoCampanhaTipoProduto, this.recursos, 'card-produtos'));
        this.tipos.push(new RecursoCampanhaFormTipo(recursoCampanhaTipoServico, this.recursos, 'card-servicos'));
        this.calcularValorTotal();
    }

    /** Calcula o valor total de todos os recursos */
    calcularValorTotal() {
        this.valorTotal = 0;
        this.tipos?.forEach(tipo => {
            this.valorTotal += tipo.valorTotal;
        });
    }

    /** Ao alterar o valor de algum retorno */
    onChangeRecursoValor(tipo: RecursoCampanhaFormTipo) {
        if (!tipo) {
            return;
        }
        // Calculando valor total do tipo do recurso
        tipo.calcularValorTotal();
        // Calculando valor total dos recursos
        this.calcularValorTotal();
    }

    /** Abre/Fecha o collapse do card */
    toggleCollapse(tipo: RecursoCampanhaFormTipo) {
        if (!tipo) {
            return;
        }

        if (!tipo.isCollapseOpened) {
            this.openCollapse(tipo);
        } else {
            this.closeCollpase(tipo);
        }
    }

    /** Abre o collapse do card */
    openCollapse(tipo: RecursoCampanhaFormTipo) {
        if (!tipo) {
            return;
        }

        tipo.isCollapseOpened = true;
        (jQuery(`#collapse_${tipo.id}`) as any).collapse('show');
    }

    /** Fecha o collapse do card */
    closeCollpase(tipo: RecursoCampanhaFormTipo) {
        if (!tipo) {
            return;
        }

        tipo.isCollapseOpened = false;
        (jQuery(`#collapse_${tipo.id}`) as any).collapse('hide');
    }

    insert(tipo: RecursoCampanhaFormTipo) {
        if (!tipo) {
            return;
        }

        this.openCollapse(tipo);
        tipo.insert();
        setTimeout(() => {
            jQuery(`#recurso_${tipo.id}_${tipo.recursos.length - 1}`).trigger('focus');
        }, 300);
    }

    delete(tipo: RecursoCampanhaFormTipo, index: number) {
        if (!tipo || index < 0) {
            return;
        }

        const recurso = tipo.recursos[index];
        this.messageService.confirm(`Deseja realmente excluir o ${tipo.nome} ${recurso.recursoCampanha?.nome ?? ''}?`).then(result => {
            if (result) {
                tipo.delete(index);
                this.calcularValorTotal();
            }
        });
    }

    isValid(): boolean {
        for (let i = 0; i < this.tipos.length; i++) {
            const tipo = this.tipos[i];
            for (let j = 0; j < tipo.recursos.length; j++) {
                const recurso = tipo.recursos[j];
                if (!recurso.idRecursoCampanha) {
                    this.messageService.warning(`Selecione o recurso ou remova da lista de ${tipo.nomePlural}`, 'Atenção');
                    jQuery(`#recurso_${tipo.id}_${j}`).trigger('focus');
                    return false;
                }
            }
        }

        return true;
    }

    resolve(): RecursoCampanhaBase[] {
        const recursos: RecursoCampanhaBase[] = [];
        let sequencia = 1;
        this.tipos.forEach(tipo => {
            tipo.recursos.forEach(recurso => {
                recurso.sequencia = sequencia;
                recursos.push(recurso);
                sequencia++;
            });
        });

        return recursos;
    }
}
